export const state = () => ({
    PERMISSIONS: [
        'academic_courses_management',
        'ads_management',
        'boards',
        'articles_management',
        'contents',
        'marathons_management',
        'settings',
        'shops_management',
        'students_management',
        'stars_products_management',
        'user_roles_management',
        'users'
    ],
    USER_ROLES_PERMISSION: 'user_roles_management'
});

export const getters = {
    PERMISSIONS: state => state.PERMISSIONS,
    USER_ROLES_PERMISSION: state => state.USER_ROLES_PERMISSION
};

export const mutations = {};

export const actions = {};
